import { render } from "./MsgSend.vue?vue&type=template&id=4d12fedf&scoped=true"
import script from "./MsgSend.vue?vue&type=script&lang=js"
export * from "./MsgSend.vue?vue&type=script&lang=js"

import "./MsgSend.vue?vue&type=style&index=0&id=4d12fedf&lang=less&scoped=true"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d12fedf"]])

export default __exports__